import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { RestService } from '../../shared/rest.service';
import { HttpClient } from '@angular/common/http';
import {setting} from '../../../../setting';

@Injectable()
export class ApiService {

	private url = setting.apiBookingUrl;

	constructor(private http: HttpClient, private _restService:RestService) {
		//
	}

	// La sesión viaja en la cookie HttpOnly auth_token; HttpConfigInterceptor
	// ya se encarga de withCredentials y de los headers comunes (x-api-user,
	// x-api-key, Content-Type) para toda llamada a apiBookingUrl — no hace
	// falta armar nada acá.

	// Generic Get Request
	doGet(endpoint: string): Observable<any> {
		return this.http
			.get(this.url + endpoint)
			.map((response:any) => response.data);
			//.catch(this.handleError);
	}

	// Generic Get Request
	doGetReservation(endpoint: string): Observable<any> {
		return this.http
			.get(this.url + endpoint)
			.map((response:any) => response);
			//.catch(this.handleError);
	}

	// Generic Post Request
	doPost(endpoint: string, param: any): Observable<any> {
		const body = JSON.stringify(param);
		return this.http
			.post(this.url + endpoint, body);
			//.map((response:any) => response)
			//.catch(this.handleError);
	}

	// Generic Put Request
	doPut(endpoint: string, param: any): Observable<any> {
		const body = JSON.stringify(param);
		return this.http
			.put(this.url + endpoint, body)
			//.map((response:any) => response)
			//.catch(this.handleError);
	}

	// Generic Delete Request
	doDelete(endpoint: string): Observable<any> {
		return this.http
			.delete(this.url + endpoint)
			.map((response:any) => response);
			//.catch(this.handleError);
	}

	// Handling errors in response
	handleError(error: Response | any) {
		let errMsg: string;
		if (error instanceof Response) {
			const body:any = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}
		return Observable.throw(errMsg);
	}

	add(item: any, reservation?) {
		console.log("ADD de api service", item);
		console.log("ADD de api service", reservation);
		// item.reserveData = reservation;
		const storage = this.storage();
		const itinerary = JSON.parse(storage.getItem('itinerary'));
		const items: Array<any> = itinerary['items'];
		for (let i = 0; i < items.length; i++) {
			if (items[i].id === item.id) {
				items[i] = item;
			}
		}
		this.setItem(itinerary);
		this._restService.doPost('app', 'itineraries', itinerary).subscribe((response:any) => {
			console.log('Add-Success: ', response);
			if (reservation) {
				this._restService.doPost('app', 'reservations', reservation).subscribe(response2 => {
					console.log('Reservation-Success: ', response2);
				}, error => {
					console.log('Reservation-Error: ', error);
				});
			}
		}, error => {
			console.log('Add-Error: ', error);
		});
	}

	setItem(itinerary: any) {
		const storage = this.storage();
		storage.setItem('itinerary', JSON.stringify(itinerary));
	}
	storage() {
		let credentials = localStorage;
		if (sessionStorage.getItem('credentials') != null) {
			credentials = sessionStorage;
		}
		return credentials;
	}
}
